module.exports = __webpack_public_path__ + "static/media/help.8ff3ac0e.png";